export default class AddedMatchesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.events === undefined || content.events.add === undefined) {
            return;
        }

        const matches = content.events.add;

        for (let i = 0; i < matches.length; i++) {
            const match = matches[i];

            const key = this._modelKeyRepository.addMatch(match.l, match.id);

            matches[i] = Object.assign({
                timeAndZone: match.taz,
                name: match.n,
                firstTeam: match.ft,
                secondTeam: match.st,
                notice: match.ntc,
                type: match.t,
                realSportId: match.rs,
                outcomesCount: match.oc,
                radarId: match.te,
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/AddedMatchesModifier.js